// extracted by mini-css-extract-plugin
export default {"container":"vSi1R8MaEZhy1J6FiJVZ"};